import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import moment from 'moment';
import * as types from './types';
import {userLogout, forbiddenAccess} from  './auth';
const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
    .use(function(req) {
        req.on('response', function (res) {
            if (res.status === 401) {
            console.log('UnAuthorized');
              userLogout();
                
            }else if(res.status === 403){
              console.log('Forbidden');
              forbiddenAccess();
            }
        });
});



export function getInvoicesStart() {
  return {
    type: types.GET_INVOICES_START,
  };
}

export function getInvoicesSuccess({ invoices }) {
  return {
    type: types.GET_INVOICES_SUCCESS,
    invoices,
  };
}

export function getInvoicesFail() {
  return {
    type: types.GET_INVOICES_FAIL,
  };
}

export function getInvoices() {
  return (dispatch) => {
    dispatch(getInvoicesStart());

    request.get(`${window.Config.API_URL}/accounts/clients/invoices`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getInvoicesSuccess({ invoices: resp.body }));
      })
      .catch((ex) => {
        console.log('Failed to get invoices', ex);
        dispatch(getInvoicesFail());
      });
  };
}

export function getPlanStart() {
  return {
    type: types.GET_BILLING_PLAN_START,
  };
}

export function getPlanSuccess({ info }) {
  return {
    type: types.GET_BILLING_PLAN_SUCCESS,
    info,
  };
}

export function getPlanFail() {
  return {
    type: types.GET_BILLING_PLAN_FAIL,
  };
}

export function getActivePlan() {
  return (dispatch) => {
    dispatch(getPlanStart());
 request
      .get(`${window.Config.API_URL}/accounts/clients/plans/active`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        const planInfo = JSON.parse(resp.text);

        dispatch(getPlanSuccess({ info: planInfo }));
      })
      .catch((ex) => {
        console.log('Failed to fetch active plan', ex);

        dispatch(getPlanFail());
      });
  };
}

export function sendInvoiceEmailStart() {
  return {
    type: types.SEND_INVOICE_EMAIL_START,
  };
}

export function sendInvoiceEmailSuccess({ invoiceId }) {
  return {
    type: types.SEND_INVOICE_EMAIL_SUCCESS,
    invoiceId,
  };
}
export function sendInvoiceEmailFail() {
  return {
    type: types.SEND_INVOICE_EMAIL_FAIL,
  };
}

export function sendInvoiceEmail({ invoiceId, invoiceNumber, amount, dueDate }) {
  return (dispatch) => {
    dispatch(sendInvoiceEmailStart());
    const params = Object.assign(
      {},
      {
        id: invoiceId,
      },
    );
    const emailOptions = Object.assign(
      {},
      {
        email_subject: `TrueLark sent you an invoice ${invoiceNumber}`,
        email_body: `TrueLark sent you an invoice (${invoiceNumber}) for ${amount.code} ${
          amount.amount
        } that's due on ${dueDate}.`,
      },
    );

    request
      .post(`${window.Config.API_URL}/accounts/email-invoice`).withCredentials().set('X-Request-ID', uuidv4())
      .query(params)
      .send(emailOptions)
      .then(() => {
        dispatch(sendInvoiceEmailSuccess({ invoiceId }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(sendInvoiceEmailFail());
      });
  };
}

export function getCardsStart() {
  return {
    type: types.GET_CARDS_START,
  };
}

export function getCardsSuccess({ cards }) {
  return {
    type: types.GET_CARDS_SUCCESS,
    cards,
  };
}
export function getCardsFail() {
  return {
    type: types.GET_CARDS_FAIL,
  };
}

// Fetch saved credit cards for user
export function getCards() {
  return (dispatch) => {
    dispatch(getCardsStart());
    request
      .get(`${window.Config.API_URL}/accounts/clients/cards`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        const cards = JSON.parse(resp.text);

        dispatch(getCardsSuccess({ cards }));
      })
      .catch((ex) => {
        console.log('Failed to fetch list of credit cards', ex);
        dispatch(getCardsFail());
      });
  };
}

export function getDefaultCardStart() {
  return {
    type: types.GET_DEFAULT_CARD_START,
  };
}

export function getDefaultCardSuccess({ card }) {
  return {
    type: types.GET_DEFAULT_CARD_SUCCESS,
    card,
  };
}
export function getDefaultCardFail() {
  return {
    type: types.GET_DEFAULT_CARD_FAIL,
  };
}

// Fetch default credit card
export function getDefaultCard() {
  return (dispatch) => {
    dispatch(getDefaultCardStart());
request
      .get(`${window.Config.API_URL}/accounts/clients/cards/default`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        const card = JSON.parse(resp.text);

        dispatch(getDefaultCardSuccess({ card }));
      })
      .catch((ex) => {
        console.log('Failed to fetch default credit card', ex);

        dispatch(getDefaultCardFail());
      });
  };
}

export function addCardStart() {
  return {
    type: types.ADD_CARD_START,
  };
}

export function addCardSuccess() {
  return {
    type: types.ADD_CARD_SUCCESS,
  };
}

export function addCardFail({ error }) {
  return {
    type: types.ADD_CARD_FAIL,
    error,
  };
}

export function addCard({ tokenId }) {
  return (dispatch) => {
    dispatch(addCardStart());
    const params = Object.assign(
      {},
      {
        card: {
          fingerprint: tokenId,
        },
      },
    );

    request
      .post(`${window.Config.API_URL}/accounts/clients/cards`).withCredentials().set('X-Request-ID', uuidv4())
      .send(params)
      .then(() => {
        dispatch(addCardSuccess());
      })
      .catch((ex) => {
        console.log('Failed to add card', ex);

        dispatch(addCardFail({ error: { message: ex.response.text } }));
      });
  };
}

export function unsubscribePlanStart() {
  return {
    type: types.UNSUBSCRIBE_PLAN_START,
  };
}

export function unsubscribePlanSuccess() {
  return {
    type: types.UNSUBSCRIBE_PLAN_SUCCESS,
  };
}

export function unsubscribePlanFail() {
  return {
    type: types.UNSUBSCRIBE_PLAN_FAIL,
  };
}

export function unsubscribePlan() {
  return (dispatch, getState) => {
    dispatch(unsubscribePlanStart());

    const { softwares } = getState();
    const params = Object.assign(
      {},
      {
        bz_id: softwares.info.STUDIO_ID,
        unsubscribe_reason: '',
        unsubscribe_date: moment().format('YYYY-MM-DD'),
      },
    );

    request
      .post(`${window.Config.API_URL}/business/unsubscribe`).withCredentials().set('X-Request-ID', uuidv4())
      .set('Authorization', 'TechSupport123')
      .send(params)
      .then(() => {
        dispatch(unsubscribePlanSuccess());
      })
      .catch((ex) => {
        console.log('Failed to unsubscribe client', ex);

        dispatch(unsubscribePlanFail());
      });
  };
}

const getAvailablePlansStart = () => {
  return {
    type: types.GET_AVAILABLE_PLANS_START,
  };
};

const getAvailablePlansSuccess = ({ plans }) => {
  return {
    type: types.GET_AVAILABLE_PLANS_SUCCESS,
    plans,
  };
};
const getAvailablePlansFail = () => {
  return {
    type: types.GET_AVAILABLE_PLANS_FAIL,
  };
};

export function getAvailablePlans() {
  return (dispatch) => {
    dispatch(getAvailablePlansStart());
    request
      .get(`${window.Config.API_URL}/accounts/clients/plans/available`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getAvailablePlansSuccess({ plans: resp.body }));
      })
      .catch((ex) => {
        console.log('Failed to fetch list of plans', ex);

        dispatch(getAvailablePlansFail());
      });
  };
}

const getClientStart = () => {
  return {
    type: types.GET_CLIENT_START,
  };
};
const getClientSuccess = ({ client }) => {
  return {
    type: types.GET_CLIENT_SUCCESS,
    client,
  };
};
const getClientFail = () => {
  return {
    type: types.GET_CLIENT_FAIL,
  };
};

export function getClient() {
  return ((dispatch) => {
    dispatch(getClientStart());
request
      .get(`${window.Config.API_URL}/accounts/clients`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(dispatch(getClientSuccess({ client: resp.body })));
      })
      .catch((ex) => {
        console.log('Failed to fetch client', ex);

        dispatch(getClientFail());
      });
  });
}

const updatePlanStart = () => {
  return {
    type: types.UPDATE_PLAN_START,
  };
};

const updatePlanSuccess = ({ message }) => {
  return {
    type: types.UPDATE_PLAN_SUCCESS,
    message,
  };
};

const updatePlanFail = () => {
  return {
    type: types.UPDATE_PLAN_FAIL,
  };
};

export function updateActivePlan({ planId }) {
  return (dispatch, getState) => {
    dispatch(updatePlanStart());

    const { auth } = getState();

    const params = {
      plan_id: planId,
      date: moment().format('YYYY-MM-DD'),
    };

    request
      .put(`${window.Config.API_URL}/accounts/clients/plans`).withCredentials().set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        // Fetch available plans
        dispatch(getAvailablePlans());

        // Fetch client details
        dispatch(getClient());

        dispatch(updatePlanSuccess({ message: resp.body.message }));
      })
      .catch((ex) => {
        console.log('Failed to update active plan', ex);

        dispatch(updatePlanFail());
      });
  };
}
